module.exports = __webpack_public_path__ + "mr.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/mr.svg
// module id = 703
// module chunks = 0